module.exports = __webpack_public_path__ + "static/media/background-cnc.91b8bf6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-cnc.jpg
// module id = 954
// module chunks = 0